// CustomIcon.tsx
import { ElementType, useState } from "react";
import type { SvgIconComponent } from "@mui/icons-material";
import * as Styles from "./CustomIcon.styles.";

interface CustomIconProps {
  Icon: ElementType | SvgIconComponent;
  color?: string;
  hoverColor?: string;
  size?: string;
}

export default function CustomIcon({ Icon, color, hoverColor, size }: CustomIconProps) {
  const [isHovered, setIsHovered] = useState(false);
  const styles = Styles.getIconStyle({ color, hoverColor, isHovered, size });

  const isMaterialIcon = (Icon as SvgIconComponent).muiName === "SvgIcon";

  if (isMaterialIcon) {
    return <Styles.MaterialUiIcon iconColor={color} iconHoverColor={hoverColor} iconSize={size} />;
  }

  return (
    <Icon
      style={styles}
      onMouseEnter={hoverColor ? () => setIsHovered(true) : undefined}
      onMouseLeave={hoverColor ? () => setIsHovered(false) : undefined}
    />
  );
}
